<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V9H3V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z"
      fill="#21BF54"
    />
    <path
      d="M3 9H21V21C21 21.5304 20.7893 22.0391 20.4142 22.4142C20.0391 22.7893 19.5304 23 19 23H5C4.46957 23 3.96086 22.7893 3.58579 22.4142C3.21071 22.0391 3 21.5304 3 21V9Z"
      fill="#D5D8DC"
    />
    <path d="M8 2H6V6H8V2Z" fill="#363C43" />
    <path d="M18 2H16V6H18V2Z" fill="#363C43" />
    <path
      d="M12.8905 11H7.23047V16.66H9.23047V14.42L12.1805 17.37L13.5905 15.96L10.6405 13H12.8805V11H12.8905Z"
      fill="#363C43"
    />
    <path
      d="M11.1095 20.5547H16.7695V14.8947H14.7695V17.1347L11.8195 14.1847L10.4095 15.5947L13.3595 18.5547H11.1195V20.5547H11.1095Z"
      fill="#363C43"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
